import { render, staticRenderFns } from "./AssetLevel2.vue?vue&type=template&id=50bee4f4"
import script from "./AssetLevel2.vue?vue&type=script&lang=js"
export * from "./AssetLevel2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports